import DeviantsBar from './DeviantsBar';
import DeviantsBarContainer from './DeviantsBar.container';

export default DeviantsBarContainer(DeviantsBar);
